<template>
  <div :class="$style.hangUp">
    <div :class="$style.header">
      <i :class="`iconfont yw-xiangzuo ${$style.icon}`" @click="back" v-if="step" />
      <span>{{ title }}</span>
      <img :src="`${$cdnLink}/suspend/tongyong/guanbi.png`" alt @click="close" :class="$style.closePage" />
    </div>
    <main v-if="!step && !deviceList.length">
      <img :src="cloud_hang_up_image" alt="" :class="$style.banner" />
      <div :class="$style.buyMore" >
        <i class="iconfont yw-shuaxin1" @click="refreshDeviceList"></i>
        <button :class="$style.submit" @click="setStep(1, '购买云手机')">购买云手机</button>
      </div>
    </main>
    <main v-if="!step && deviceList.length">
      <ul :class="$style.deviceList">
        <li v-for="(item, index) in deviceList" :key="index" @click="enterCloudPhone(item)">
          <img :src="item.picture" alt="" :class="$style.back" v-if="item.picture">
          <div :class="$style.mask"></div>
          <div :class="$style.info">
            <span>{{ item.custom_name }}</span>
            <img :src="`${$cdnLink}/common/edit.png?v=1`" alt="" @click.stop="editDevice(item)" />
          </div>
          <div :class="$style.remain">
            <span>到期时间：</span>
            <p>{{ item.valid_end_time }}</p>
          </div>
          <div :class="$style.operation">
            <div @click.stop="refreshDevice(item)"> 
              <img :src="`${$cdnLink}/common/refresh.png?v=1`" alt="" />
              <p>刷新</p>
            </div>
            <div @click.stop="restartDevice(item)">
              <img :src="`${$cdnLink}/common/restart.png?v=1`" alt="" />
              <p>重启</p>
            </div>
            <div @click.stop="toRenewal(item)">
              <img :src="`${$cdnLink}/common/renewal.png?v=1`" alt="" />
              <p>续费</p>
            </div>
          </div>
        </li>
      </ul>
      <div :class="$style.buyMore" >
        <i class="iconfont yw-shuaxin1"  @click="refreshDeviceList"></i>
        <button :class="$style.submit" @click="setStep(1, '购买云手机')">购买更多云手机</button>
      </div>
      <div :class="$style.redirect">
        <span @click="setStep(4, '云手机使用说明')">云手机使用说明</span>
        <div>
          <span @click="setStep(2, '购买记录')">购买记录</span>
          <span @click="setStep(5, '问题反馈')" :class="$style.feedBack">问题反馈</span>
        </div>
      </div>
    </main>
    <!-- 购买新云手机 -->
    <main v-if="step === 1">
      <ul :class="$style.product">
        <li
          v-for="(item, index) in product"
          :key="index"
          :class="currentBuyDevice.goods_id === item.goods_id ? $style.active : ''"
          @click="selectProduct(item)"
        >
          <div :class="$style.section">
            <span :class="$style.day">{{ item.duration }}天</span>
            <div>
              <span :class="$style.original" v-if="item.ori_price">￥{{ item.ori_price }}</span>
              <span :class="$style.price">￥{{ item.cur_price }}</span>
            </div>
          </div>
          <div :class="$style.section2">
            <span>{{ item.days_price }}元/1天</span>
            <span v-if="item.box_price && cloud_relation_status == 2">盒子内购买只需{{ item.box_price }}元</span>
          </div>
        </li>
      </ul>
      <div v-if="currentBuyDevice" :class="$style.priceDisplay">
        <div :class="$style.step">
          <div>
            <span>数量：</span>
            <Stepper v-model="num" theme="round" button-size="18" disable-input max="10" min="1" />
          </div>
          <span>购买多台云手机，可轻松多开挂机</span>
        </div>
        <div :class="$style.price">
          <span :class="$style.total">共{{ num }}台，各{{ currentBuyDevice.duration }}天</span>
          <div>
            <span>合计:</span>
            <span :class="$style.totalPrice">￥{{ (num * currentBuyDevice.cur_price).toFixed(2) }}</span>
          </div>
        </div>
      </div>
      <button :class="$style.submit" @click="purchase(0)">确认支付</button>
      <p :class="[$style.redirect, $style.alone]" v-if="cloud_hang_up_box_url && cloud_relation_status == 2" @click="redirectBox">前往玩心盒子内购买，全部档位再享95折</p>
    </main>
    <!-- 购买记录 -->
    <main v-if="step === 2">
      <ul v-if="recordList.length" :class="$style.record">
        <li :class="$style.title">
          <span>商品名称</span>
          <span>购买价格</span>
          <span>购买时间</span>
        </li>
        <li v-for="(item, index) in recordList" :key="index">
          <span>{{ item.goods_name }}</span>
          <span>{{ item.money }}元</span>
          <span>{{ item.pay_time }}</span>
        </li>
      </ul>
      <div v-else :class="$style.empty">
        <img :src="`${$cdnLink}/suspend/tongyong/record.png`" alt="" />
        <p>当前没有购买记录</p>
      </div>
    </main>
    <!-- 续费 -->
    <main v-if="step === 3">
      <ul :class="$style.product">
        <li
          v-for="(item, index) in product"
          :key="index"
          :class="currentBuyDevice.goods_id === item.goods_id ? $style.active : ''"
          @click="selectProduct(item)"
        >
          <div :class="$style.section">
            <span :class="$style.day">{{ item.duration }}天</span>
            <div>
              <span :class="$style.original" v-if="item.ori_price">￥{{ item.ori_price }}</span>
              <span :class="$style.price">￥{{ item.cur_price }}</span>
            </div>
          </div>
          <div :class="$style.section2">
            <span>{{ item.days_price }}元/1天</span>
            <span v-if="item.box_price && cloud_relation_status == 2">盒子内购买只需{{ item.box_price }}元</span>
          </div>
        </li>
      </ul>
      <div :class="$style.renewalInfo">
        <p>当前设备：{{ currentRenewalDevice.custom_name }}</p>
        <div v-if="currentBuyDevice" :class="$style.price">
          <span>续费{{ currentBuyDevice.duration }}天</span>
          <div>
            <span>合计: </span>
            <span :class="$style.priceNum">￥{{ currentBuyDevice.cur_price }}</span>
          </div>
        </div>
      </div>
      <button :class="$style.submit" @click="purchase(1)">确认支付</button>
      <p :class="[$style.redirect, $style.alone]" v-if="cloud_hang_up_box_url && cloud_relation_status == 2" @click="redirectBox">前往玩心盒子内购买，全部档位再享95折</p>
    </main>
    <main v-if="step === 4" :class="$style.description">
      <span :class="$style.feed" @click="setStep(5, '问题反馈')">问题反馈</span>
      <ul>
        <li v-for="(item, index) in description" :key="index">
          <div :class="$style.q" @click="item.state = !item.state">
            <img :src="`${$cdnLink}/cloud/q.png`" alt="" :class="$style.icon">
            <p>{{ item.question }}</p>
            <img :src="`${$cdnLink}/cloud/back.png`" alt="" :class="[item.state ? $style.show : $style.hide, $style.back]">
          </div>
          <div :class="[item.state ? $style.show : $style.hide, $style.a]">
            <img :src="`${$cdnLink}/cloud/a.png`" alt="" :class="$style.icon">
            <div>
              <p>{{ item.answer_content }}</p>
              <img :src="item.answer_pic_url" alt="" v-if="item.answer_pic_url">
              <!-- <video :src="item.answer_video_url"></video> -->
              <video controls="controls" width="100%" v-if="item.answer_video_url">
                <source :src="item.answer_video_url" type="video/mp4">
              </video>
            </div>
          </div>
        </li>
      </ul>
    </main>
    <main v-if="step === 5" :class="$style.feedback">
      <p>云手机体验如何，评价一下吧</p>
      <CheckboxGroup :class="$style.feedRadioGroup" v-model="feedbackType" direction="horizontal">
        <div v-for="(item, index) in feedbackTypeList" :key="index" :class="$style.feedRadio">
          <Checkbox :name="item.name" checked-color="#ff4f4b" icon-size="15px"></Checkbox>
          <span>{{ item.name }}</span>
        </div>
      </CheckboxGroup>
      <Field
        v-model="feedText"
        rows="4"
        type="textarea"
        maxlength="300"
        placeholder="还有其他想法或建议，写下来告诉我们吧。"
        show-word-limit
        :class="$style.feedText"
      /> 
      <div :class="$style.setPrompt" v-if="showPrompt">
        <Checkbox @change="setPrompt" checked-color="#ff4f4b" icon-size="15px" v-model="prompt"></Checkbox>
        <span>不再提示</span>
      </div>
      <button :class="$style.submit" @click="submitFeedback">提交</button>
    </main>
    <EditDeviceName
      v-if="editDeviceVisible"
      @close="editDeviceVisible = false"
      :currentDevice="currentDevice"
      @success="editDeviceSuccess"
    ></EditDeviceName>
    <VersionHint v-if="versionHintVisible" @close="versionHintVisible = false"></VersionHint>
    <DownloadHint v-if="downloadHintVisible" @close="downloadHintVisible = false"></DownloadHint>
    <BoxDownload v-if="boxDownLoadShow" @close="boxDownLoadShow = false" type="wx"></BoxDownload>
  </div>
</template>
<script>
import { Stepper, Checkbox, CheckboxGroup, Field } from 'vant';
import { mapState } from 'vuex';
import { commonPayOrderList } from '@/api/pay';
import { feedbackType as getFeedbackTypeList, feedbackSubmit, getCloudFAQ } from '@/api/suspend';
import EditDeviceName from './EditDeviceName.vue';
import VersionHint from './VersionHint.vue';
import DownloadHint from './DownloadHint.vue';
import { backFromCloudApp,gameOpenDownloads, tencentCloudAppStartDevice, skipWXBox2Sdk, tencentCloudAppRestartDevice, tencentCloudAppRefreshDevice, cloudAppScreenShotCallback, tencentCloudSetDevices } from '@/bridge/AppJsBridge';
import { isAndroid, versionCompare, isPure } from '@/libs/utils.js';
import { redirBoxNewVersion, cloudOldVersion } from '@/libs/business/version';
import { buryReportV2 } from '@/libs/business/account';
import { wxBoxDownloadUrl } from '@/config'
import BoxDownload from '@/components/Suspend/common/boxDownload.vue';
import { generActLink } from '@/libs/business/box';

export default {
  data() {
    return {
      step: 0,
      lastStep: 0,
      currentBuyDevice: '', // 购买新机时候代表新机器设备信息 续费时代表当前续费档位信息
      title: '云手机',
      lastTitle: '云手机',
      num: 1,
      recordList: [],
      currentRenewalDevice: '', // 当前续费设备
      editDeviceVisible: false,
      versionHintVisible: false,
      downloadHintVisible: false,
      descriptionVisible: false,
      currentDevice: '', // 当前选中的已购买的设备 编辑用
      deviceList: [],
      boxDownLoadShow: false, 
      cloud_relation_status: '',
      description: [],
      feedbackTypeList: [],
      feedbackType: [],
      feedText: '',
      noPromptCache: false,
      showPrompt: false,
      prompt: false
    };
  },
  created() {
    this.deviceList = this.$store.state.suspend.cloudDeviceList || [];
    this.cloud_relation_status = this.$getStorage('cloud_relation_status');
    this.getFeedbackType()
  },
  mounted() {
    const uploadCache = this.$getStorage('buryport') || {};
    buryReportV2('CLOUD_HANG_UP_TAB', {
      cloud_hang_up_template_id: this.cloud_hang_up_template_id,
      cloud_hang_up_template_name: this.cloud_hang_up_template_name,
      menu_name: "云挂机",
      ...uploadCache
    });
    this.eventListener();
    this.getCloudFAQ();
  },
  computed: {
    ...mapState({
      // deviceList: (state) => state.suspend.cloudDeviceList,
      cloud_hang_up_box_url: (state) => state.suspend.cloud_hang_up_box_url,
      cloud_hang_up_image: (state) => state.suspend.cloud_hang_up_image,
      cloud_hang_up_template_id: (state) => state.suspend.cloud_hang_up_template_id,
      cloud_hang_up_template_name: (state) => state.suspend.cloud_hang_up_template_name,
      product: (state) => state.suspend.cloudProductList,
    }),
  },
  methods: {
    async getCloudFAQ() {
      const faq = await getCloudFAQ();
      this.description = faq.content.faq_list.map(item => {
        return {
          ...item,
          state: 0
        }
      })
    },
    async getFeedbackType() {
      const r = await getFeedbackTypeList();
      this.feedbackTypeList = r.content.options;
    },
    back() {
      if (this.step === 5) {
        this.step = this.lastStep;
        this.title = this.lastTitle;
      } else {
        this.step = 0;
        this.title = '云手机';
      }
    },
    setStep(val, title) {
      this.lastStep = this.step;
      this.lastTitle = this.title;
      this.step = val;
      this.title = title;
      console.log(this.lastStep, this.lastTitle, this.step, this.title)
      if (val === 1) {
        buryReportV2('CLOUD_HANG_UP_BUY_CLICK', {
          cloud_hang_up_template_id: this.cloud_hang_up_template_id,
          cloud_hang_up_template_name: this.cloud_hang_up_template_name,
        });
        this.currentBuyDevice = this.product[0]
      }
      if (val === 2) {
        this.getOrderRecord()
      }
      if (val === 5) {
        this.feedbackType = []
        this.feedText = ''
        this.showPrompt = false;
      }
    },
    selectProduct(item) {
      this.currentBuyDevice = item;
    },
    // type 0. 购买新机 1. 续费
    async purchase(type) {
      if (cloudOldVersion()) {
        if (this.cloud_relation_status == 2) {
          this.versionHintVisible = true;
        } else {
          this.downloadHintVisible = true;
        }
        return;
      }
      const r = await this.$store.dispatch('pay/cloudPreCreatOrder', {
        money: this.currentBuyDevice.cur_price,
        goodsId: this.currentBuyDevice.goods_id,
        goodsName: this.currentBuyDevice.goods_name,
        num: type ? 1 : this.num,
        operateType: type,
        userPhoneId: type ? this.currentRenewalDevice.user_phone_id : '',
        days: this.currentBuyDevice.duration,
      });
      if (r) {
        this.$store.commit('suspend/CHANGE_STATE', { cloudChargeVisible: true });
      }
      buryReportV2('CLOUD_HANG_UP_CONFIRM_PAY_CLICK', {
        cloud_hang_up_template_id: this.cloud_hang_up_template_id,
        cloud_hang_up_template_name: this.cloud_hang_up_template_name
      });
    },
    async enterCloudPhone(item) {
      if (!cloudOldVersion()) {
        const user_id = this.$getStorage('user_id');
        console.log('tencentCloudAppStartDevice 调用');
        tencentCloudAppStartDevice({
          userPhoneId: item.user_phone_id,
          userId: user_id,
          index: item.index
        });
        buryReportV2('CLOUD_HANG_UP_DEVICE_CLICK', {
          cloud_hang_up_template_id: this.cloud_hang_up_template_id,
          cloud_hang_up_template_name: this.cloud_hang_up_template_name,
          custom_name: item.custom_name,
          user_phone_id: item.user_phone_id,
        }); 
      } else {
        if (this.cloud_relation_status == 2) {
          this.versionHintVisible = true;
        } else {
          this.downloadHintVisible = true;
        }
      }
    },
    setPrompt(val) {
      this.$setStorage('noPromptCache', val);
    },
    toRenewal(item) {
      this.currentRenewalDevice = item;
      this.currentBuyDevice = this.product[0];
      this.step = 3;
      buryReportV2('CLOUD_HANG_UP_DEVICE_RENEW', {
        cloud_hang_up_template_id: this.cloud_hang_up_template_id,
        cloud_hang_up_template_name: this.cloud_hang_up_template_name,
        custom_name: item.custom_name,
        user_phone_id: item.user_phone_id,
      }); 
    },
    editDevice(item) {
      this.currentDevice = item;
      this.editDeviceVisible = true;
    },
    editDeviceSuccess(device_name) {
      this.currentDevice.custom_name = device_name;
      this.editDeviceVisible = false;
      tencentCloudSetDevices({
        devices: this.deviceList
      });

    },
    close() {
      buryReportV2('CLOUD_HANG_UP_CLOSE', {
        cloud_hang_up_template_id: this.cloud_hang_up_template_id,
        cloud_hang_up_template_name: this.cloud_hang_up_template_name
      });
      this.$emit('close')
    },
    async redirectBox() {
      if (redirBoxNewVersion()) {
        skipWXBox2Sdk({
          event: 'boxAnyPage',
          syAppkey: "",
          boxUrl: wxBoxDownloadUrl(),
          routePath: '/cloud/CloudMainActivity'
        })
      } else {
        const gameUrl = await generActLink(this.cloud_hang_up_box_url);
        gameOpenDownloads({
          gameUrl
        });
        this.boxDownLoadShow = true;
      }
      buryReportV2('CLOUD_HANG_UP_GO_TO_CLICK_GOODS', {
        cloud_hang_up_template_id: this.cloud_hang_up_template_id,
        cloud_hang_up_template_name: this.cloud_hang_up_template_name,
        cloud_hang_up_box_url: this.cloud_hang_up_box_url
      });
    },
    async refreshDevice(item) {
      const appkey = this.$getStorage('appkey');
      const user_id = this.$getStorage('user_id');
      console.log('tencentCloudAppRefreshDevice 调用', item);
      tencentCloudAppRefreshDevice({
        userPhoneId: item.user_phone_id,
        userId: user_id,
        index: item.index
      })
      buryReportV2('CLOUD_HANG_UP_DEVICE_REFRESH', {
        cloud_hang_up_template_id: this.cloud_hang_up_template_id,
        cloud_hang_up_template_name: this.cloud_hang_up_template_name,
        custom_name: item.custom_name,
        user_phone_id: item.user_phone_id,
      }); 
    },
    async restartDevice(item) {
      const appkey = this.$getStorage('appkey');
      const user_id = this.$getStorage('user_id');
      console.log('tencentCloudAppRestartDevice 调用');
      tencentCloudAppRestartDevice({
        userPhoneId: item.user_phone_id,
        userId: user_id
      });
      buryReportV2('CLOUD_HANG_UP_DEVICE_RESTART', {
        cloud_hang_up_template_id: this.cloud_hang_up_template_id,
        cloud_hang_up_template_name: this.cloud_hang_up_template_name,
        custom_name: item.custom_name,
        user_phone_id: item.user_phone_id,
      });
    },
    async getOrderRecord() {
      const user_id = this.$getStorage('user_id');
      const r = await commonPayOrderList({ user_id });
      this.recordList = r.content.order_records;
    },
    eventListener() {
      cloudAppScreenShotCallback((data) => {
        data = JSON.parse(data);
        const currentDevice = this.deviceList.find(item => item.user_phone_id == data.userPhoneId);
        currentDevice.picture = data.picture;
      })
      backFromCloudApp(() => {
        this.noPromptCache = this.$getStorage('noPromptCache') || false;
        // 云机返回sdk显示问题反馈，若未点击过不再提示，则会弹框。
        if (!this.noPromptCache) {
          this.lastStep = this.step;
          this.lastTitle = this.title;
          this.step = 5;
          this.title = '问题反馈';
          this.showPrompt = true;
        }
      })
    },
    async refreshDeviceList() {
      this.$store.commit('global/showLoading')
      this.deviceList = await this.$store.dispatch('suspend/getCloudDeviceList');
      this.$store.commit('global/clearLoading')
    },
    async submitFeedback() {
      if (!this.feedbackType.length && !this.feedText) {
        this.$toast('请评价后再提交哦~')
        return;
      }
      const user_id = this.$getStorage('user_id');
      const appkey = this.$getStorage('appkey');
      const extra_data = JSON.parse(this.$getStorage('extra_data'));
      await feedbackSubmit({
        user_id,
        content: this.feedText,
        type_name: this.feedbackType.join(','),
        appkey,
        package_type: isPure() ? 1: 2,
        extra_data 
      })
      this.$toast('提交成功');
      this.step = this.lastStep;
      this.title = this.lastTitle;
    }
  },
  components: {
    Stepper,
    EditDeviceName,
    VersionHint,
    BoxDownload,
    DownloadHint,
    CheckboxGroup,
    Checkbox,
    Field
  },
};
</script>
<style module lang="scss">
@import '../common.scss';

.hangUp {
  @include common-h5-wrap();
  position: relative;
  height: 100%;
  .header {
    position: relative;
    border: none;
    .icon {
      position: absolute;
      left: 0px;
      font-size: 15px;
      padding: 5px;
    }
  }
  main {
    .banner {
      width: 95%;
      height: 270px;
      display: block;
      margin: auto;
    }
    .buyMore {
      display: flex;
      justify-content:center;
      align-items: center;
      width: 100%;
      padding-top: 6px;
      :global {
        .yw-shuaxin1 {
          font-size: 18px;
          margin-right: 10px;
          &:active {
            opacity: 0.7;
          }
        }
      }
      .submit {
        margin: 0;
      }
    }
    .submit {
      width: 150px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 12px;
      border: none;
      outline: none;
      background: #ff5b58;
      border-radius: 20px;
      margin: 6px auto 0;
      &:active {
        opacity: 0.7;
      }
    }
    .product {
      height: 190px;
      overflow-y: auto;
      padding: 10px 0 4px;
      background: #f8f8f8;
      > li {
        width: 310px;
        background: #ffffff;
        border-radius: 10px;
        margin: auto {
          bottom: 6px;
        }
        padding: 8px 10px;
        &.active {
          border: 1px solid #ff5b58;
          background-color: #fdefef;
        }

        .section,
        .section2 {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .section {
          margin-bottom: 8px;
          > span:nth-child(1) {
            font-size: 12px;
            color: #525252;
          }
          .original {
            font-size: 9px;
            color: #939393;
            text-decoration: line-through;
          }
          .price {
            font-size: 14px;
            color: #ff5b58;
          }
        }
        .section2 {
          font-size: 9px;
          color: #959595;
        }
      }
    }
    .priceDisplay {
      font-size: 11px;
      padding: 8px 10px;
      .step {
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        > div {
          display: flex;
          align-items: center;
        }
        > span {
          font-size: 12px;
        }
      }
      .price {
        display: flex;
        align-items: center;
        justify-content: space-between;
        > div {
          display: flex;
          align-items: center;
        }
      }
      .total {
        color: #939393;
        margin-right: 4px;
      }
      .totalPrice {
        font-size: 15px;
        color: #ff5b58;
        margin-bottom: 3px;
      }
    }
    .redirect {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      font-size: 10px;
      text-decoration: underline;
      text-align: center;
      color: #097ed9;  
      margin-top: 8px;
      .feedBack {
        margin-left: 80px;
      }
      &.alone {
        justify-content: center;
      }
    }
    .deviceList {
      text-align: center;
      height: 260px;
      overflow-y: auto;
      > li {
        position: relative;
        display: inline-block;
        margin: 6px 15px 15px;
        padding: 8px;
        width: 120px;
        height: 200px;
        background: url('#{$cdn-url}/common/cloud_phone_bg.png?v=1') no-repeat;
        background-size: 100% 100%;
        border-radius: 10px;
        color: #ffffff;
        .back {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          border: none;
          border-radius: 10px;
        }
        .mask {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background-color: rgba(0, 0, 0, 0.3);
          border-radius: 10px;
        }
        img {
          width: 14px;
          height: 14px;
        }
        :global {
          .van-count-down {
            color: #ffffff;
            font-size: 8px;
          }
        }
        .info {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
          margin-bottom: 2px;
        }
        .remain {
          position: relative;
          margin-top: 5px;
          line-height: 16px;
          font-size: 10px;
          text-align: left;
        }
        .operation {
          width: 110px;
          display: flex;
          align-items: center;
          justify-content: space-around;
          position: absolute;
          bottom: 10px;
          font-size: 12px;
          > div {
            &:active {
              opacity: 0.7;
            }
          }
        }
      }
    }
    .empty {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 120px;
      > img {
        width: 88px;
        height: 88px;
      }
      > p {
        text-align: center;
        color: #7a7979;
        font-size: 12px;
        opacity: 0.7;
      }
    }
    .record {
      font-size: 10px;
      padding: 5px 10px;
      .title {
        border-bottom: 1px solid #b7b7b7;
      }
      > li {
        padding: 8px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        > span {
          width: 33.3%;
          text-align: center;
        }
      }
    }
    .renewalInfo {
      font-size: 12px;
      padding: 8px;
      > p {
        font-size: 12px;
        margin-top: 8px;
        font-weight: 500;
        margin-bottom: 4px;
      }
      .price {
        border-top: 0.1px solid #8f8f8f;
        padding-top: 4px;
        margin-top: 4px;
        display: flex;
        justify-content: space-between;
        > span {
          color: #939393;
        }
        .priceNum {
          color: #ff5b58;
          font-size: 15px;
        }
      }
    }
  }
  .description {
    font-size: 12px;
    position: relative;
    padding: 26px 12px;
    background-color: #F8F8F8;
    height: calc(100% - 34px);
    .feed {
      color: #1BA4CC;
      display: inline-block;
      position: absolute;
      top: 10px;
      right: 12px;
    }
    > ul {
      > li {
        background-color: #FFFFFF;
        border-radius: 5.5px;
        box-shadow: 0px 0px 2px 0px rgba(131,131,131,0.61); 
        padding: 7px 12px;
        margin-bottom: 10px;
        .q {
          position: relative;
          display: flex;
          align-items: center;
          font-size: 12px;
          .icon {
            margin-right: 15px;
            width: 18px;
            height: 18px;
          }
          .back {
            position: absolute;
            right: 0;
            transform: rotate(90deg);
            &.hide {
              transform: rotate(270deg);
            }
          }
        }
        .a {
          display: flex;
          color: #7E7E7E;
          margin-top: 10px;
          line-height: 16px;
          &.hide {
            display: none;
          }
          .icon {
            margin-right: 15px;
            width: 18px;
            height: 18px;
          }
          > div {
            img {
              width: 100%;
              display: block;
              margin: 0;
              outline: 0;
            }
            video {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .feedback {
    font-size: 12px;
    background-color: #F8F8F8;
    > p {
      font-weight: 400;
      text-align: center;
      color: #000000;
      font-size: 13px;
      margin-top: 27px;
      margin-bottom: 17px;
    }
    .feedRadioGroup {
      text-align: center;
      padding: 0 20px;
      .feedRadio {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 23px;
        margin-right: 30px;
        width: 40%;
        margin-bottom: 15px;
      }
    }
    .feedText {
      width: 261px;
      margin: auto;
      font-size: 12px;
      background-color: #D7D7D7;
      :global {
        .van-field__control {
          &::placeholder {
            color: #676767;
          }
        }
      }
    }
    .setPrompt {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10px 0;
      > span {
        margin-left: 5px;
      }
    }
  }
}
</style>

